import type { PaginatedRequestParams, PaginatedResponse } from '@/types/api';
import type { SentCycle } from '@/types/cycle-evaluation/SentCycle';

import { api } from '@/api/api';

export default {
    async getSentCycles({
        pageNumber,
        pageSize,
        meta,
        signal,
    }: PaginatedRequestParams & { signal?: AbortSignal }): Promise<PaginatedResponse<SentCycle>> {
        const cycleEvaluationId = meta?.cycleEvaluationId;

        if (!cycleEvaluationId) {
            throw new Error('cycleEvaluationId is required to fetch sent cycles');
        }

        const response = await api.get<PaginatedResponse<SentCycle>>(
            `/cycleevaluation/${cycleEvaluationId}/launchcycles`,
            {
                params: { pageNumber, pageSize },
                signal,
            },
        );

        return response.data;
    },
};
